import React from 'react';
export function ForYourBabySection() {
  return <section className="bg-[#faf7f4] py-[100px] px-6 font-serif overflow-hidden" data-id="element-69">
      <div className="max-w-[1100px] mx-auto flex flex-col-reverse md:flex-row items-center gap-10 md:gap-20 flex-wrap justify-center" data-id="element-70">
        {/* ── COLUMNA IZQUIERDA: COPY ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[500px] flex flex-col gap-7 text-left" data-id="element-71">
          {/* Badge superior */}
          <span className="inline-block w-fit bg-[#f0e8e0] text-[#8B5E52] text-[11px] font-sans font-bold tracking-[2.5px] uppercase py-[7px] px-[18px] rounded-full" data-id="element-72">
            ✦ Una decisión que cambia todo
          </span>

          {/* Título principal */}
          <h2 className="text-[clamp(30px,4vw,46px)] text-[#2c1810] leading-[1.25] m-0 font-bold" data-id="element-73">
            Hazlo por él.
            <br data-id="element-74" />
            <span className="text-[#8B5E52] italic font-normal" data-id="element-75">
              Hazlo por ti también.
            </span>
          </h2>

          {/* Línea divisoria decorativa */}
          <div className="w-[60px] h-[3px] bg-[#c9a090] rounded-sm" data-id="element-76" />

          {/* Párrafo 1 — Para el bebé */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-77">
            Esos pequeños pies que ves ahora mismo{' '}
            <strong className="text-[#2c1810]" data-id="element-78">
              no van a estar pequeños por mucho tiempo.
            </strong>{' '}
            El primer año de vida es la única ventana en la que el cerebro de tu
            bebé se construye a una velocidad que nunca volverá a repetirse. Lo
            que pase en estos 365 días{' '}
            <strong className="text-[#2c1810]" data-id="element-79">
              importa más que cualquier otra cosa
            </strong>{' '}
            que harás como padre o madre.
          </p>

          {/* Párrafo 2 — Para el padre/madre */}
          <p className="text-[17px] leading-[1.85] text-[#5a4a42] font-sans m-0" data-id="element-80">
            Pero también es verdad esto:{' '}
            <strong className="text-[#2c1810]" data-id="element-81">
              un padre agotado no puede dar lo mejor de sí.
            </strong>{' '}
            Necesitas dormir. Necesitas claridad. Necesitas saber que lo estás
            haciendo bien. Este protocolo no es solo para tu bebé —{' '}
            <strong className="text-[#2c1810]" data-id="element-82">
              es para que tú también respires.
            </strong>
          </p>

          {/* 3 micro-puntos emocionales */}
          <div className="flex flex-col gap-3.5 mt-1" data-id="element-83">
            {[{
            icon: '🤍',
            text: 'Para que cada momento cuente, sin culpa y sin miedo.'
          }, {
            icon: '🧠',
            text: 'Para que tu bebé llegue al año con una base neurológica sólida.'
          }, {
            icon: '🌙',
            text: 'Para que tú vuelvas a dormir y a disfrutar esta etapa.'
          }].map((item, i) => <div key={i} className="flex items-start gap-3.5 bg-white border-[1.5px] border-[#ede5df] rounded-2xl py-3.5 px-[18px] shadow-[0_2px_12px_rgba(0,0,0,0.04)]" data-id="element-84">
                <span className="text-[20px] leading-none" data-id="element-85">{item.icon}</span>
                <p className="m-0 text-[15px] leading-[1.6] text-[#5a4a42] font-sans" data-id="element-86">
                  {item.text}
                </p>
              </div>)}
          </div>

          {/* Quote cierre */}
          <blockquote className="mt-2 mb-0 py-5 px-6 bg-[#f5ede8] border-l-4 border-[#c9a090] rounded-r-2xl italic text-base text-[#7a5a50] leading-[1.7] font-serif" data-id="element-87">
            "No se trata de ser el padre perfecto. Se trata de ser el padre{' '}
            <strong className="font-bold" data-id="element-88">presente y preparado</strong> que tu
            bebé necesita."
          </blockquote>
        </div>

        {/* ── COLUMNA DERECHA: IMAGEN ── */}
        <div className="flex-1 min-w-[300px] md:min-w-[380px] max-w-full md:max-w-[480px] w-full relative" data-id="element-89">
          {/* Círculo decorativo de fondo */}
          <div className="hidden md:block absolute top-[-30px] right-[-30px] w-[300px] h-[300px] bg-[#f0e8e0] rounded-full z-0 opacity-60" data-id="element-90" />

          {/* Imagen principal */}
          <img src="https://cdn.magicpatterns.com/uploads/jzjQnDTanrZZDAVwUqbuCx/ChatGPT_Image_1_abr_2026,_12_15_07_a.m..png" alt="Pies de bebé junto a tablet con Su Primer Año" className="w-full h-auto rounded-3xl shadow-[0_30px_80px_rgba(0,0,0,0.15)] relative z-10 block" data-id="element-91" />

          {/* Floating card — social proof */}
          <div className="absolute bottom-6 left-[-20px] bg-white rounded-2xl py-3.5 px-5 shadow-[0_10px_40px_rgba(0,0,0,0.12)] z-20 flex items-center gap-3 max-w-[240px]" data-id="element-92">
            <span className="text-[28px]" data-id="element-93">👶</span>
            <div data-id="element-94">
              <p className="m-0 text-[13px] font-bold text-[#2c1810] font-sans" data-id="element-95">
                +2,400 familias
              </p>
              <p className="m-0 text-[12px] text-[#9a8880] font-sans" data-id="element-96">
                ya viven esta diferencia
              </p>
            </div>
          </div>

          {/* Floating card — estrellitas */}
          <div className="absolute top-6 right-[-10px] bg-white rounded-2xl py-3 px-[18px] shadow-[0_10px_40px_rgba(0,0,0,0.10)] z-20 text-center" data-id="element-97">
            <p className="m-0 text-base tracking-[2px]" data-id="element-98">⭐⭐⭐⭐⭐</p>
            <p className="mt-1 mb-0 text-[11px] text-[#9a8880] font-sans font-semibold" data-id="element-99">
              4.9 / 5 · 847 reseñas
            </p>
          </div>
        </div>
      </div>
    </section>;
}